import { render, staticRenderFns } from "./LabelProjectsEdit.vue?vue&type=template&id=fe724658"
import script from "./LabelProjectsEdit.vue?vue&type=script&lang=js"
export * from "./LabelProjectsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports